import styled from 'styled-components';


export const CheckboxContainer = styled.div`

display: flex;
align-items: center;

.form-check-input {
    shadow-box: none;
    width: 1.3em;
    height: 1.3em;
}

.form-check-input:checked {
    background-color: ${props => props.theme.primary};
    border-color: ${props => props.theme.primary};
}

.form-check-label {
    padding-left: 5px;
}

`